function waitForElement(o, t) {
    window.setTimeout(function() {
        $(o).length ? t(o, $(o)) : waitForElement(o, t)
    }, 200)
}

function GoToVideo() {
    $("html, body").animate({
        scrollTop: $("#viewtipsytray").offset().top - 200
    }, 1e3);
    var o = $("#viewtipsytray iframe").prop("src");
    o += "?autoplay=1", $("#viewtipsytray iframe").prop("src", o)
}
$(function() {
    waitForElement(".scrolltotop", function() {
        $(".scrolltotop").after("<img src='//cdn.shopify.com/s/files/1/0275/6971/7387/files/hand_arrow_1.png?v=1588275174' class='scrolltopimage'>"),
        $(".scrolltopimage").click(function() {
            return $("html, body").animate({
                scrollTop: 0
            }, "slow"), !1
        })
    }), $(".scrolltotop").click(function() {
        return $("html, body").animate({
            scrollTop: 0
        }, "slow"), !1
    }), $(".scrolltopimage").click(function() {
        return $("html, body").animate({
            scrollTop: 0
        }, "slow"), !1
    })
}); 